import mockAxios, { AxiosResponse } from 'axios';

import { IInventoryAdvancePaymentServiceMock } from './inventoryadvancepayment.mock.types';
import { IInventoryAdvancePaymentData } from '@/models';

export const mockInventoryAdvancePaymentService = (): IInventoryAdvancePaymentServiceMock => ({
  fetchInventoryAdvancePayments: jest.fn(),
  fetchInventoryAdvancePayment: jest.fn(),
  createInventoryAdvancePayment: jest.fn(),
  updateInventoryAdvancePayment: jest.fn(),
  deleteInventoryAdvancePayment: jest.fn(),
  deleteInventoryAdvancePaymentAttachment: jest.fn(),
  addInventoryAdvancePaymentAttachments: jest.fn(),
  updateInventoryAdvancePaymentState: jest.fn(),
  fetchInventoryAdvancePaymentAPSpecialists: jest.fn(),
  assignInventoryAdvancePaymentAPSpecialist: jest.fn(),
  fetchInventoryAdvancePaymentApprovers: jest.fn(),
  fetchCurrentAvailableAssignees: jest.fn(),
  fetchInventoryAdvancePaymentFinanceManagers: jest.fn(),
  assignInventoryAdvancePaymentFinanceManager: jest.fn(),
  assignInventoryAdvancePaymentApprover: jest.fn(),
  updateInventoryAdvancePaymentOwner: jest.fn(),
  fetchInventoryAdvancePaymentActivities: jest.fn(),
  // comments
  fetchInventoryAdvancePaymentComments: jest.fn(),
  fetchInventoryAdvancePaymentComment: jest.fn(),
  createInventoryAdvancePaymentComment: jest.fn(),
  updateInventoryAdvancePaymentComment: jest.fn(),
  deleteInventoryAdvancePaymentComment: jest.fn(),

  addInventoryAdvancePaymentCommentAttachments: jest.fn(),
  removeInventoryAdvancePaymentCommentAttachment: jest.fn(),

  fetchInventoryAdvancePaymentCommentsMentionableUsers: jest.fn(),

  //export
  exportInventoryAdvancePaymentPdf: jest.fn(),
  exportInventoryAdvancePayments: jest.fn(),

  updateMultipleInventoryAdvancePaymentOwner: jest.fn()
});

export const mockInventoryAdvancePaymentAxiosResponse = <
  T = IInventoryAdvancePaymentData
>(
  data?: T
): AxiosResponse<T | undefined> => {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
};
